module.exports = __webpack_public_path__ + "static/img/e772ad9c6164c92f345dab00081c0a67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon1.jpg
// module id = pmzQ
// module chunks = 1